import React from 'react';
import { CpWidgetVariantType } from 'api/customer-portal/types';
import { CpWidgetProps } from '../../types/widget';
import { CpFooterWithLinkGroupOnBottom } from './variants/cp-footer-with-link-group-on-bottom';
import { CpFooterWithLinkGroupOnRight } from './variants/cp-footer-with-link-group-on-right';
import { CpFooterWithoutLinkGroups } from './variants/cp-footer-without-link-groups';

export const CpFooter: React.FC<CpWidgetProps> = ({
  disabled,
  data,
  widget,
  projectId,
  onRuntimeConfigChange,
  runtimeConfig,
}) => {
  const widgetData = data as any;

  switch (widget?.widgetVariantType) {
    case CpWidgetVariantType.FooterWithoutLinkGroups:
    case undefined:
      return (
        <CpFooterWithoutLinkGroups
          disabled={disabled}
          data={widgetData}
          widget={widget}
          projectId={projectId}
          onRuntimeConfigChange={onRuntimeConfigChange}
          runtimeConfig={runtimeConfig}
        />
      );
    case CpWidgetVariantType.FooterWithLinkGroupOnright:
      return (
        <CpFooterWithLinkGroupOnRight
          disabled={disabled}
          data={widgetData}
          widget={widget}
          projectId={projectId}
          onRuntimeConfigChange={onRuntimeConfigChange}
          runtimeConfig={runtimeConfig}
        />
      );
    case CpWidgetVariantType.FooterWithLinkGroupOnBottom:
      return (
        <CpFooterWithLinkGroupOnBottom
          disabled={disabled}
          data={widgetData}
          widget={widget}
          projectId={projectId}
          onRuntimeConfigChange={onRuntimeConfigChange}
          runtimeConfig={runtimeConfig}
        />
      );
    default:
      return <></>;
  }
};
